/**
 * Copyright 2024, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __awaiter } from "tslib";
import { addEventListener } from '@react-native-community/netinfo';
import { BatchEventProcessor } from './batch_event_processor';
export class ReactNativeNetInfoEventProcessor extends BatchEventProcessor {
    constructor(config) {
        super(config);
        this.isInternetReachable = true;
    }
    connectionListener(state) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isInternetReachable && !state.isInternetReachable) {
                this.isInternetReachable = false;
                return;
            }
            if (!this.isInternetReachable && state.isInternetReachable) {
                this.isInternetReachable = true;
                this.retryFailedEvents();
            }
        });
    }
    start() {
        super.start();
        this.unsubscribeNetInfo = addEventListener(this.connectionListener.bind(this));
    }
    stop() {
        var _a;
        (_a = this.unsubscribeNetInfo) === null || _a === void 0 ? void 0 : _a.call(this);
        super.stop();
    }
}
export const __platforms = ['react_native'];
//# sourceMappingURL=batch_event_processor.react_native.js.map